<!-- Loading bar -->
<app-loading-bar-onpush></app-loading-bar-onpush>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-8" src="assets/images/logo/mini-logo-white.svg" alt="Lingueo">
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User menu profil -->
        <div class="flex flex-col items-center w-full p-4 mb-6">

            <div
                class="w-30 h-30 group relative flex items-center justify-center rounded-full overflow-hidden ring-bg-card">
                @if (student && student.user && student.user.photo_profile?.photo_identity) {
                <img class="w-full h-full rounded-full object-cover" [src]="student.user.photo_profile?.photo_identity">
                } @else {
                <div
                    class="flex items-center justify-center w-full h-full rounded-full text-8xl font-semibold uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                    <mat-icon class="icon-size-24" [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                </div>
                }
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <!-- Footer content (vide pour l'instant) -->
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Mobile menu button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button> 

        <!-- Formation Switcher (sélecteur de formation) -->
        <div class="flex items-center ml-2 sm:ml-4 min-w-0 flex-1">
            <app-formation-switcher></app-formation-switcher>
        </div>

        <!-- Components (languages, fullscreen, search, etc.) -->
        <div class="flex items-center pl-2 ml-auto space-x-2 sm:space-x-4 flex-shrink-0">
            <!-- TODO: Ajouter sélecteur de langue (languages-translate-fuse) -->
            <languages-translate-fuse></languages-translate-fuse>

            <!-- Fullscreen button (optionnel) -->
            <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Modal du prochain cours imminent -->
    <app-next-session-modal></app-next-session-modal>

    <!-- Achievement modals -->
    @if (student) {
        <app-achievement-modal-fuse [slug]="'release'" [student]="student" />
        <app-achievement-modal-fuse [slug]="'first-login'" [student]="student" />
    }

    <!-- Footer (optionnel) -->
    <!--
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Lingueo &copy; {{currentYear}}</span>
    </div>
    -->

</div>